import React, { useState } from "react";

const Nav = () => {
    let Links = [
        {name:"HOME", link:"/"},
        {name:"ABOUT", link:"/AboutUs"},
        {name:"PRODUCTS", link:"/Products"},
        {name:"GALLERY", link:"/Gallery"},
        {name:"NEWS", link:"/News"},
        {name:"CONTACT US", link:"/ContactUs"}
    ];

    let [open,setOpen] = useState(false);

    return (
        <div className="shadow-md w-full fixed top-0 left-0 z-50">
            <div className="desktop:flex items-center justify-between bg-white py-6 mobile:px-10 px-7">
                {/* Logo */}
                <a
                    href="/"
                    className="font-bold text-2xl cursor-pointer flex items-center font-[Poppins] text-orange-600"
                >
                    Dian Cempaka
                </a>

                {/* Hamburger Icon */}
                <div
                    onClick={() => setOpen(!open)}
                    className="text-3xl absolute right-8 top-6 cursor-pointer laptop:hidden text-orange-600"
                >
                    {/* Hamburger Icon Changes on Toggle */}
                    <ion-icon name={open ? "close" : "menu"}></ion-icon>
                </div>

                {/* Navigation Links */}
                <ul
                    className={`tablet:flex items-center md:pb-0 pb-12 absolute md:static bg-white md:z-auto z-[-1] left-0 w-full md:w-auto md:pl-0 pl-9 transition-all duration-500 ease-in ${
                        open ? "top-16" : "top-[-490px]"
                    }`}
                >
                    {Links.map((Link) => (
                        <li
                            key={Link.name}
                            className="laptop:ml-8 text-md font-semibold hover:before:bg-redborder-red-500 relative h-[24px] w-30 overflow-hidden bg-white px-2 text-red-500 transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-red-500 before:transition-all before:duration-500 hover:text-white hover:before:left-0 hover:before:w-full md:my-0 my-7"
                        >
                            <a href={Link.link} className="relative z-10">
                                {Link.name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Nav;